import { render } from "./CreateTattooModal.vue?vue&type=template&id=7cbeac15"
import script from "./CreateTattooModal.vue?vue&type=script&lang=js"
export * from "./CreateTattooModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__